import { DocumentData, SupportingDocumentMetadata } from "types";
import { supportingFilename } from "./supportingDocumentFiles";

export const supportingCategories = [
  "description",
  "drawings",
  "calculations",
  "reports",
  "incorporation",
  "conformity",
  "certificates",
  "supplier_manuals",
  "images",
  "other",
] as const;
export type DocumentVisibility = "internal" | "external";
export const defaultSupportingMetadata = (
  filename: string,
): SupportingDocumentMetadata => ({
  title: filename.replace(/\.[^.]+$/, "") || filename,
  category: "other",
  visibility: "internal",
});
export const supportingMetadata = (
  doc: DocumentData,
): SupportingDocumentMetadata => ({
  ...defaultSupportingMetadata(supportingFilename(doc)),
  ...doc.metadata,
  title: doc.metadata?.title || supportingFilename(doc),
});
export const supportingVisibility = (doc: DocumentData): DocumentVisibility =>
  doc.metadata?.visibility === "external" ? "external" : "internal";
export type Validity = "none" | "valid" | "expiring" | "expired";
export const documentValidity = (
  date?: string,
  today = new Date(),
): Validity => {
  if (!date) return "none";
  const end = new Date(`${date}T00:00:00`);
  if (Number.isNaN(end.getTime())) return "none";
  const start = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  );
  const days = Math.round((end.getTime() - start.getTime()) / 86400000);
  return days < 0 ? "expired" : days <= 60 ? "expiring" : "valid";
};
export const supportingArchiveFolder = (doc: DocumentData) => {
  const category = supportingMetadata(doc).category;
  const folders: Record<string, string> = {
    description: "Beschreibung",
    drawings: "Zeichnungen",
    calculations: "Berechnungen",
    reports: "Prüfberichte",
    incorporation: "Einbauerklärungen",
    conformity: "EU-Konformitätserklärungen Zukaufteile",
    certificates: "Zertifikate",
    images: "Bilder",
    other: "Sonstige",
    supplier_manuals: "Betriebs- und Montageanleitungen Zulieferer",
  };
  return `${supportingVisibility(doc) === "external" ? "Extern" : "Intern"}/${folders[category] || folders.other}`;
};

export const supportingManagementPath = (projectId: string) =>
  `/projects/${projectId}?tab=supporting-documents`;
